import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchPatientSubscriptionBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for replacing addon items on a patient's Stripe subscription. Invalidates the subscription and invoice queries on success. */
export function useUpdatePatientSubscription(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PatchPatientSubscriptionBody) => {
      const response = await api.patch('/patients/:patientId/subscription', {
        params: { patientId },
        body,
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', patientId, 'subscription'] })
      queryClient.invalidateQueries({ queryKey: ['patient', patientId, 'invoices'] })
    },
  })
}
